import { useMediaQuery, ThemeProvider, useTheme } from '@mui/material_v7';
import { ReactNode } from 'react';

export type { Theme } from '@mui/material_v7/styles';

import getTheme, { WLColor } from '@uptime/design-system/theme/muiTheme';

interface Props {
  children: ReactNode;
  wlColor?: WLColor;
}

export const ThemeProviderV7 = ({ children, wlColor }: Props) => (
  <ThemeProvider theme={getTheme(wlColor)}>{children}</ThemeProvider>
);

export const useThemeV7 = useTheme;
export const useMediaQueryV7 = useMediaQuery;
